import Vue from 'vue'
import VueRouter from 'vue-router'
import MapView from '../views/map/MapView.vue'
import ListView from '../views/ListView.vue'
import AddPriceView from '../views/AddPriceView.vue'
import VerifyView from '../views/VerifyView.vue'
import SubmittedView from '../views/SubmittedView.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import ImprintPage from '../views/ImprintPage.vue'

Vue.use(VueRouter)

/**
 * Renders views and components via routing
 */
const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: MapView
  },
  {
    path: '/list',
    name: 'List',
    component: ListView
  },
  {
    path: '/neuer-eintrag',
    name: 'NeuerEintrag',
    component: AddPriceView
  },
  {
    path: '/verifizieren',
    name: 'Verifizieren',
    component: VerifyView
  },
  {
    path: '/eintrag-erstellt',
    name: 'EintragErstellt',
    component: SubmittedView
  },
  {
    path: '/datenschutzerklaerung',
    name: 'Datenschutz',
    component: PrivacyPolicy
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: ImprintPage
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
